import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { Grid, Button, IconButton, Snackbar, Typography, Avatar } from "@material-ui/core";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import ManagedActCard from "./ManagedActCard";
import ClearIcon from "@material-ui/icons/Clear";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import GroupIcon from "@material-ui/icons/Group";
import BlockIcon from "@material-ui/icons/Block";
import Loading from "../loadingSpinner/Loading";
import SearchCard from "../searchPage/SearchCard";
import image from "../../helper/image";

import "./ActList.css";
import { ProfileType } from "../../types/enum";

@inject("profileStore", "searchStore", "userStore", "rosterStore")
@observer
class ActList extends Component {
    state = {
        expanded: false,
        openDeleteConfirmationModal: false,
        deletedActId: undefined,
        deletedActName: "",
        openSnackbar: false,
        snackbarMessage: "",
        acceptConfirmationState: false,
        declineConfirmationState: false,
        selectedInvitationAct: null
    };

    componentDidMount() {
        const profile = this.props.profileStore.getCurrentProfile()
        if (this.props.agentAct) {
            return this.props.profileStore.getAgentActList();
        }
        if(profile.type === ProfileType.PrivateHire.ordinal){
            this.props.profileStore.getPrivateHireFavouriteActList();
        }else{
            this.props.profileStore.getUserActList();
        }
        
    }

    handleExpandClick = () => {
        this.setState({
            expanded: !this.state.expanded
        });
    };

    handleOpenDeleteConfirmation = id => {
        const act = this.props.profileStore.actList.slice().find(x => x.id === id);
        this.setState({
            deletedActName: act ? act.actName : "",
            openDeleteConfirmationModal: true,
            deletedActId: id
        });
    };

    handleCancelDelete = () => {
        this.setState({
            openDeleteConfirmationModal: false,
            deletedActId: undefined
        });
    };

    handleRemove = () => {
        this.props.profileStore.deleteProfile(this.state.deletedActId).then(response => {
            this.handleCancelDelete();
            this.setState({
                snackbarMessage: `${this.state.deletedActName} has been deleted.`,
                openSnackbar: true
            });
        });
    };

    getProfileUrl = profile => {
        return profile.vanityUrl && profile.vanityUrl.length > 3 ? `/${profile.vanityUrl}` : `/profile/${profile.id}`;
    };

    handleAddRemoveFavourite = (act) => {
        if(act.isFavourite){
            this.props.userStore.removeActAsUserFavourite(act.id).then(result => {
                this.props.profileStore.setFavouriteOnSearch(act.id, !act.isFavourite)
          
            });
        }else{
            this.props.userStore.addActAsUserFavourite(act.id).then(result => {
                this.props.profileStore.setFavouriteOnSearch(act.id, !act.isFavourite)
            });
        }
       
    };

    closeSnackbarContainer = () => {
        this.setState({
            snackbarMessage: "",
            openSnackbar: false
        });
    };

    handleOpenAcceptConfirmation = (act) => {
        this.setState({
            acceptConfirmationState: true,
            selectedInvitationAct: act
        });
    };

    handleOpenDeclineConfirmation = (act) => {
        this.setState({
            declineConfirmationState: true,
            selectedInvitationAct: act
        });
    };

    handleCloseInvitationConfirmation = () => {
        this.setState({
            acceptConfirmationState: false,
            declineConfirmationState: false,
            selectedInvitationAct: null
        });
    };

    handleAcceptInvitation = () => {
        const { selectedInvitationAct } = this.state;
        if (selectedInvitationAct) {
            this.props.rosterStore.acceptDeclineRequest(selectedInvitationAct.id, true).then(() => {
                this.props.profileStore.getUserActList();
                this.handleCloseInvitationConfirmation();
                this.setState({
                    snackbarMessage: `You have joined ${selectedInvitationAct.actName}!`,
                    openSnackbar: true
                });
            });
        }
    };

    handleDeclineInvitation = () => {
        const { selectedInvitationAct } = this.state;
        if (selectedInvitationAct) {
            this.props.rosterStore.acceptDeclineRequest(selectedInvitationAct.id, false).then(() => {
                this.props.profileStore.getUserActList();
                this.handleCloseInvitationConfirmation();
                this.setState({
                    snackbarMessage: `You have declined the invitation to ${selectedInvitationAct.actName}.`,
                    openSnackbar: true
                });
            });
        }
    };

    getActSubheader = (act) => {
        let subheader = "";
        if (act.lineUpCount) {
            const lineupTypes = {
                1: "Solo",
                2: "Duo",
                3: "Trio",
                4: "4 Piece",
                5: "5 Piece",
                6: "6+ Piece"
            };
            subheader = lineupTypes[act.lineUpCount] || `${act.lineUpCount} Piece`;
        }
        if (act.vibesName) {
            subheader = subheader ? `${subheader} / ${act.vibesName}` : act.vibesName;
        }
        if (act.genreName) {
            subheader = subheader ? `${subheader} / ${act.genreName}` : act.genreName;
        }
        return subheader;
    };

    render() {
        const profile = this.props.profileStore.getCurrentProfile()
        
        let renderAct = act => {
            return (
                <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={act.id}>
                    {
                        profile?.type === ProfileType.PrivateHire.ordinal ? 
                        ( 
                            <SearchCard
                                profileId={act.id}
                                profileName={act.actName}
                                profileBio={act.bio}
                                profile={act}
                                type="act"
                                userRole={this.props.profileStore.profile?.type}
                                profileUrl={this.getProfileUrl(act)}
                                isFavourite={act.isFavourite}
                                handleAddRemoveFavourite={() => this.handleAddRemoveFavourite(act)}
                            />
                        ) : 
                        (
                            <ManagedActCard act={act} handleRemove={() => this.handleOpenDeleteConfirmation(act.id)} type="act" profile={profile} agentAct={this.props.agentAct} />
                        )
                    }
                    
                </Grid>
            );
        };

        const { fullScreen } = false;
        const { isLoadingProfile } = this.props.profileStore;
        const { actList } = this.props.profileStore;

        const isPrivateHire = profile?.type === ProfileType.PrivateHire.ordinal;
        const isMusician = profile?.type === ProfileType.Musician.ordinal;
        const usesSectionedLayout = isMusician && !this.props.agentAct;

        const pendingInvitations = usesSectionedLayout ? actList.filter(act => !act.accepted && !act.myAct) : [];
        const myOwnedActs = usesSectionedLayout ? actList.filter(act => act.myAct) : [];
        const actsIPerformIn = usesSectionedLayout ? actList.filter(act => act.accepted && !act.myAct) : [];

        return (
            <Grid container direction="column" style={{ position: "relative", minHeight: "200px" }}>
                {actList.length < 1 && <Loading showed={isLoadingProfile} />}

                {isPrivateHire || (!usesSectionedLayout && !isPrivateHire) ? (
                    <Grid item xs={12}>
                        <Grid container spacing={16}>
                            {actList.map(act => renderAct(act))}
                        </Grid>
                    </Grid>
                ) : (
                    <Fragment>
                        {pendingInvitations.length > 0 && (
                            <div className="invitation-section">
                                <div className="invitation-header">
                                    <div className="invitation-icon">
                                        <MailOutlineIcon style={{ color: 'white', fontSize: 20 }} />
                                    </div>
                                    <Typography variant="h6" className="invitation-title">Pending Invitations</Typography>
                                    <span className="invitation-count">{pendingInvitations.length}</span>
                                    <Typography variant="body2" className="invitation-subtitle">You've been invited to join these acts</Typography>
                                </div>
                                <div className="invitation-cards">
                                    {pendingInvitations.map(act => (
                                        <div className="invitation-card" key={act.id}>
                                            <Avatar 
                                                className="invitation-avatar" 
                                                src={image.getProfileImage(act)} 
                                                alt={act.actName}
                                            />
                                            <div className="invitation-info">
                                                <Typography className="invitation-act-name">{act.actName}</Typography>
                                                <Typography className="invitation-meta">{this.getActSubheader(act)}</Typography>
                                            </div>
                                            <div className="invitation-actions">
                                                <Button 
                                                    className="btn-decline" 
                                                    onClick={() => this.handleOpenDeclineConfirmation(act)}
                                                >
                                                    Decline
                                                </Button>
                                                <Button 
                                                    className="btn-accept" 
                                                    onClick={() => this.handleOpenAcceptConfirmation(act)}
                                                >
                                                    Accept
                                                </Button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {myOwnedActs.length > 0 && (
                            <Grid item xs={12} style={{ width: '100%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px', paddingBottom: '12px', borderBottom: '1px solid rgba(255, 255, 255, 0.2)' }}>
                                    <Typography variant="h6" style={{ color: '#ffffff', fontSize: '20px', fontWeight: 500, margin: 0 }}>Acts You Own and Manage</Typography>
                                    <span className="section-count">{myOwnedActs.length}</span>
                                </div>
                                <Grid container spacing={16}>
                                    {myOwnedActs.map(act => renderAct(act))}
                                </Grid>
                            </Grid>
                        )}

                        {actsIPerformIn.length > 0 && (
                            <Grid item xs={12} style={{ width: '100%' }}>
                                {myOwnedActs.length > 0 && <div style={{ height: '1px', background: 'rgba(255, 255, 255, 0.15)', margin: '8px 0 32px 0', width: '100%' }} />}
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px', paddingBottom: '12px', borderBottom: '1px solid rgba(255, 255, 255, 0.2)' }}>
                                    <Typography variant="h6" style={{ color: '#ffffff', fontSize: '20px', fontWeight: 500, margin: 0 }}>Acts You Perform In</Typography>
                                    <span className="section-count">{actsIPerformIn.length}</span>
                                </div>
                                <Grid container spacing={16}>
                                    {actsIPerformIn.map(act => renderAct(act))}
                                </Grid>
                            </Grid>
                        )}

                        {actList.length === 0 && !isLoadingProfile && (
                            <div className="empty-state">
                                <Typography variant="h6">No Acts Yet</Typography>
                                <Typography variant="body2">Create your first act to get started!</Typography>
                            </div>
                        )}
                    </Fragment>
                )}

                <Dialog
                    fullScreen={fullScreen}
                    open={this.state.openDeleteConfirmationModal}
                    onClose={this.handleCancelDelete}
                    aria-labelledby="responsive-dialog-title"
                    className="dialog-div"
                >
                    <DialogTitle id="responsive-dialog-title">Delete Act</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure to delete <strong>{this.state.deletedActName}</strong>?
                            <br />Rosters and bookings with <strong>{this.state.deletedActName}</strong> will be cancelled.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCancelDelete} color="primary">
                            Close
                        </Button>
                        <Button onClick={this.handleRemove} color="primary" autoFocus>
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.acceptConfirmationState}
                    onClose={this.handleCloseInvitationConfirmation}
                    aria-labelledby="accept-dialog-title"
                    className="dialog-div invitation-dialog"
                    PaperProps={{ style: { borderRadius: '12px', overflow: 'hidden', minWidth: '380px' } }}
                >
                    <div style={{ background: 'linear-gradient(135deg, #FF0C9C 0%, #ff4db8 100%)', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <GroupIcon style={{ color: '#ffffff', fontSize: '24px' }} />
                        <Typography variant="h6" style={{ color: '#ffffff', fontSize: '18px', fontWeight: 500, margin: 0 }}>Join Act</Typography>
                    </div>
                    <DialogContent style={{ padding: '24px 20px' }}>
                        <DialogContentText style={{ color: '#333', fontSize: '15px', lineHeight: 1.6 }}>
                            You've been invited to join <strong>{this.state.selectedInvitationAct?.actName}</strong>. As a member, you'll appear on the act's profile and be eligible for bookings.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ padding: '12px 20px 20px', gap: '12px' }}>
                        <Button 
                            onClick={this.handleCloseInvitationConfirmation} 
                            style={{ color: '#666', border: '1px solid #ddd', borderRadius: '6px', padding: '8px 20px', textTransform: 'none' }}
                        >
                            Not Now
                        </Button>
                        <Button 
                            onClick={this.handleAcceptInvitation} 
                            style={{ background: '#FF0C9C', color: 'white', borderRadius: '6px', padding: '8px 24px', textTransform: 'none', fontWeight: 500 }}
                            autoFocus
                        >
                            Join Act
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.declineConfirmationState}
                    onClose={this.handleCloseInvitationConfirmation}
                    aria-labelledby="decline-dialog-title"
                    className="dialog-div invitation-dialog"
                    PaperProps={{ style: { borderRadius: '12px', overflow: 'hidden', minWidth: '380px' } }}
                >
                    <div style={{ background: 'linear-gradient(135deg, #FF0C9C 0%, #ff4db8 100%)', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <BlockIcon style={{ color: '#ffffff', fontSize: '24px' }} />
                        <Typography variant="h6" style={{ color: '#ffffff', fontSize: '18px', fontWeight: 500, margin: 0 }}>Decline Invitation</Typography>
                    </div>
                    <DialogContent style={{ padding: '24px 20px' }}>
                        <DialogContentText style={{ color: '#333', fontSize: '15px', lineHeight: 1.6 }}>
                            Are you sure you want to decline the invitation to join <strong>{this.state.selectedInvitationAct?.actName}</strong>? You can ask for another invitation later.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ padding: '12px 20px 20px', gap: '12px' }}>
                        <Button 
                            onClick={this.handleCloseInvitationConfirmation} 
                            style={{ color: '#666', border: '1px solid #ddd', borderRadius: '6px', padding: '8px 20px', textTransform: 'none' }}
                        >
                            Go Back
                        </Button>
                        <Button 
                            onClick={this.handleDeclineInvitation} 
                            style={{ background: '#d32f2f', color: 'white', borderRadius: '6px', padding: '8px 24px', textTransform: 'none', fontWeight: 500 }}
                            autoFocus
                        >
                            Decline
                        </Button>
                    </DialogActions>
                </Dialog>
                <Snackbar
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    open={this.state.openSnackbar}
                    onClose={() => this.closeSnackbarContainer()}
                    autoHideDuration={6000}
                    SnackbarContentProps={{
                        "aria-describedby": "message-id"
                    }}
                    message={<span id="message-id">{this.state.snackbarMessage}</span>}
                    action={[
                        <IconButton key="close" aria-label="Close" color="inherit" onClick={() => this.closeSnackbarContainer()}>
                            <ClearIcon />
                        </IconButton>
                    ]}
                />
            </Grid>
        );
    }
}

export default ActList;
